var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":_vm.$t('more_information_video_why_header'),"buttonLabel":_vm.$t('button_close')},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('p',[_c('a',_vm._g(_vm._b({},'a',attrs,false),on),[_vm._v(_vm._s(_vm.$t('camera_status_more_information')))])])]}}])},[_vm._v(" "+_vm._s(_vm.$t('more_information_video_why_detail'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }